import { useI18n } from '@ecom/i18n';
import { Card, Skeleton } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

export function CardSkeleton(): ReactElement {
  const { t } = useI18n();
  return (
    <Card className="p-4" role="status" aria-label={t('merchant.common.loadingAria')}>
      <Skeleton width="40%" height="0.75rem" />
      <div className="mt-2">
        <Skeleton width="70%" height="1.5rem" />
      </div>
    </Card>
  );
}
